import { INIT_PAGINATION } from '@spx-portal/shared-utils';
import { useRef, useState } from 'react';
import { message } from 'ssc-ui-react';
import { PaginationProps } from 'ssc-ui-react/typings/components/pagination/types';
import { UploadFile } from 'ssc-ui-react/typings/components/upload/types';

import { BatchImportResData, BatchImportResItem } from '../type';

const defaultPagination = {
  ...INIT_PAGINATION,
  showQuickJumper: false,
};

export default function useUpload() {
  const [showDialog, setShowDialog] = useState(false);
  const [resultData, setResultData] = useState<BatchImportResData<BatchImportResItem>>({});
  const timerRef = useRef<NodeJS.Timeout>();
  const [importing, setImporting] = useState(false);
  const [importError, setImportError] = useState(false);
  const [pagination, setPagination] = useState<PaginationProps>(defaultPagination);

  const onStart = () => {
    // 选择文件打开后，时间超过 1s，才展示 loading 态
    timerRef.current = setTimeout(() => {
      setShowDialog(true);
      setImporting(true);
    }, 1000);
  };
  const onSuccess = (data: BatchImportResData<BatchImportResItem>, file: UploadFile) => {
    clearTimeout(timerRef.current);
    setShowDialog(true);
    setImporting(false);
    setImportError(false);
    setResultData(data);
    setPagination({
      ...defaultPagination,
      total: data.list?.length,
    });
    message.success('Import successful');
  };

  const onError = () => {
    clearTimeout(timerRef.current);
    setShowDialog(true);
    setImportError(true);
    setImporting(false);
    setResultData({});
    setPagination({
      ...defaultPagination,
    });
  };

  return {
    onSuccess,
    onError,
    onStart,

    showDialog,
    setShowDialog,
    timerRef,
    resultData,
    setResultData,
    importing,
    importError,
    pagination,
    setPagination,
  };
}
